/* eslint-disable */
const boxSerilizer = (data) => {
    const newData = Object.keys(data).map((current) => {
      return {
        label: data[current].label,
        value: data[current].value,
        bgColor: data[current].color,
        icon: data[current].icon ?? 'ClipboardList',
      }
    });
    return newData;
};
const statsSerilizer = (data) => {
  const info = data[0];
  const newData = Object.keys(info).map((current) => {
    return {
      label: current,
      value: info[current],
      icon: current === 'total' ? 'ClipboardList' : current === 'passed' ? 'CircleCheck' : current === 'pass_percent' ? 'percent' : '',
    }
  });
  return newData;
}

export const configQuality = {
	boxSerilizer,
  statsSerilizer,
};
